import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DashboardAdminService {
    
  private BASE_URL: string = environment.BACKEND_RACINE_URL+'dashboard/admin';

  
  constructor(private http: HttpClient)
  {}
    

  getDashboardQuantiteUtilisateur() {
      let url: string = `${this.BASE_URL}/dashboard-quantite-utilisateur`;
    
      var reqHeader = new HttpHeaders({
        'Content-Type': 'application/json'
      });
    
      return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
        return qte;
      }));
  }
    


  getDashboardQuantiteAgence() {
    let url: string = `${this.BASE_URL}/dashboard-quantite-agence`;

    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
      return qte;
    }));
  }



  getDashboardQuantiteVille() {
    let url: string = `${this.BASE_URL}/dashboard-quantite-ville`;

    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
      return qte;
    }));
  }



  getDashboardQuantiteRegion() {
    let url: string = `${this.BASE_URL}/dashboard-quantite-region`;

    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
      return qte;
    }));
  }


  getDashboardQuantiteDirection() {
    let url: string = `${this.BASE_URL}/dashboard-quantite-direction`;

    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
      return qte;
    }));
  }



  getDashboardQuantiteDepartement() {
    let url: string = `${this.BASE_URL}/dashboard-quantite-departement`;

    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
      return qte;
    }));
  }



  getDashboardQuantiteEmployeur() {
    let url: string = `${this.BASE_URL}/dashboard-quantite-employeur`;

    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers: reqHeader }).pipe(map(qte => {
      return qte;
    }));
  }







}